module.exports = __webpack_public_path__ + "static/5-609aeeaba63f857060a3172033e8cd5f.jpg";